export const host = 'https://5cd808170cc5100014f1e32e.mockapi.io/users'